/*!
 * @jusda-tools/language-control-panel 1.1.0-alpha.0 (https://github.com/wangym/language-control-panel)
 * API https://github.com/wangym/language-control-panel/blob/master/doc/api.md
 * Copyright 2017-2025 wangym. All Rights Reserved
 * Licensed under MIT (https://github.com/wangym/language-control-panel/blob/master/LICENSE)
 */

import * as React from 'react';
import React__default from 'react';
import { CookieTools, JUSDA_LANGUAGE } from '@jusda-tools/jusda-publicmethod';
import { initCssVariables } from '@jusda-tools/jusda-theme-config';

// @ts-nocheck
const enIcon = (
// @ts-ignore
React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", t: "1610782190978", viewBox: "0 0 1024 1024", version: "1.1", "p-id": "14581", width: "30", height: "30" },
    React__default.createElement("defs", null,
        React__default.createElement("style", { type: "text/css" })),
    React__default.createElement("path", { d: "M781.7 162.4H242.3c-44.1 0-79.9 35.9-79.9 79.9v539.4c0 44.1 35.9 79.9 79.9 79.9h539.4c44.1 0 79.9-35.9 79.9-79.9V242.3c0-44.1-35.8-79.9-79.9-79.9z m39.9 619.3c0 22-17.9 39.9-39.9 39.9H242.3c-22 0-39.9-17.9-39.9-39.9V242.3c0-22 17.9-39.9 39.9-39.9h539.4c22 0 39.9 17.9 39.9 39.9v539.4z", "p-id": "14582" }),
    React__default.createElement("path", { d: "M346.3 525.2h114.9v-28.1H346.3v-62.9h122.1v-28.1h-155v215.8h160.1v-28.1H346.3zM651.8 566.6h-1.2L540.3 406.1h-33.2v215.8H540V459.6h1.2l111.5 162.3h32.1V406.1h-33z", "p-id": "14583" })));
const zhIcon = (
// @ts-ignore
React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", t: "1610782250547", viewBox: "0 0 1024 1024", version: "1.1", "p-id": "14722", width: "30", height: "30" },
    React__default.createElement("defs", null,
        React__default.createElement("style", { type: "text/css" })),
    React__default.createElement("path", { d: "M781.7 162.4H242.3c-44.1 0-79.9 35.9-79.9 79.9v539.4c0 44.1 35.9 79.9 79.9 79.9h539.4c44.1 0 79.9-35.9 79.9-79.9V242.3c0-44.1-35.8-79.9-79.9-79.9z m39.9 619.3c0 22-17.9 39.9-39.9 39.9H242.3c-22 0-39.9-17.9-39.9-39.9V242.3c0-22 17.9-39.9 39.9-39.9h539.4c22 0 39.9 17.9 39.9 39.9v539.4z", "p-id": "14723" }),
    React__default.createElement("path", { d: "M529.3 345.3V407h127.1v172.4h-33.9v-20.3h-93.2v119.6h-35V559.1h-92.8v20.3h-33.9V407h126.7v-61.8h35z m-35 180.6v-85.7h-92.8v85.7h92.8z m128.2 0v-85.7h-93.2v85.7h93.2z", "p-id": "14724" })));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".language-control-panel-container {\n  position: relative;\n  width: 50px;\n}\n.language-control-panel-container .shadow {\n  width: 80px;\n  position: relative;\n  top: 3px;\n  right: 15px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);\n}\n.language-control-panel-container .dark li {\n  opacity: 0.86;\n  background: rgba(66, 66, 66, 0.9);\n  color: #fff;\n}\n.language-control-panel-container .dark li:hover {\n  font-size: 12px;\n  color: #000000;\n  background: var(--jusda-primary-color);\n}\n.language-control-panel-container .light li {\n  background: #ffffff;\n  color: #222222;\n}\n.language-control-panel-container .light li:hover {\n  font-size: 12px;\n  color: var(--jusda-primary-button-text-color);\n  background: var(--jusda-primary-color);\n}\n.language-control-panel-container ul {\n  padding: unset;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50px;\n  cursor: pointer;\n  z-index: 100;\n}\n.language-control-panel-container ul.dark .active > svg {\n  fill: var(--jusda-primary-color);\n}\n.language-control-panel-container ul.dark .active:hover {\n  background-color: #3D3D3D;\n}\n.language-control-panel-container ul.light .active > svg {\n  fill: #222;\n}\n.language-control-panel-container ul.light .active:hover {\n  background-color: var(--jusda-action-icon-color);\n}\n.language-control-panel-container ul .active {\n  height: 50px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.language-control-panel-container ul .visible {\n  display: block;\n}\n.language-control-panel-container ul .lastChild {\n  border-bottom: none;\n}\n.language-control-panel-container ul li {\n  display: none;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  font-size: 12px;\n  width: 80px;\n}\n";
styleInject(css_248z);

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const { useState } = React;
initCssVariables();
const languages = [
    {
        locale: "zh-CN",
        name: "中文",
        icon: zhIcon,
    },
    {
        locale: "en-US",
        name: "EN",
        icon: enIcon,
    },
];
const LanguageControlPanel = ({ onClick = () => { }, theme = "light", locale = 'en-US', langOptionsExtra = [], }) => {
    const [activeLocale, setActiveLocale] = useState('en-US');
    const [visible, setVisible] = useState(false);
    const [langOptions, setLangOptions] = useState(languages);
    const handleMouseEnter = () => {
        setVisible(true);
    };
    const handleMouseLeave = () => {
        setVisible(false);
    };
    const handleClick = (locale) => {
        var farFuture = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365 * 1)); // 设置cookie过期时间为1年
        new CookieTools().set({ key: JUSDA_LANGUAGE, value: locale, configuration: { expires: farFuture } });
        setVisible(false);
        setActiveLocale(locale);
        onClick(locale);
    };
    React.useEffect(() => {
        if (langOptionsExtra && langOptionsExtra.length > 0) {
            setLangOptions([...languages, ...langOptionsExtra]);
        }
    }, [langOptionsExtra]);
    React.useEffect(() => {
        const languageStrings = langOptions.map((item) => item.locale) || [];
        if (languageStrings.includes(locale)) {
            setActiveLocale(locale);
        }
    }, [locale, langOptions]);
    const activeLanguage = langOptions.filter((item) => activeLocale === item.locale)[0];
    return (React.createElement("div", { className: "language-control-panel-container" },
        React.createElement("ul", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: theme },
            React.createElement("div", { className: "active" }, activeLanguage.icon),
            React.createElement("div", { className: "shadow" }, langOptions && langOptions.length
                ? langOptions.map(({ name, locale }, index) => {
                    return (React.createElement("li", { className: `${visible ? "visible" : ""} ${langOptions.length - 1 === index ? "lastChild" : ""}`, key: locale, onClick: () => {
                            handleClick(locale);
                        } }, name));
                })
                : null))));
};

function currentLanguage() {
    // const LANGS = ['en-US', 'zh-CN'];
    const cookieLang = new CookieTools().get(JUSDA_LANGUAGE);
    if(cookieLang && cookieLang.length > 0) {
        return cookieLang;
    }
    const isNavigatorLanguageValid = typeof navigator !== 'undefined' && typeof navigator.language === 'string';
    if(isNavigatorLanguageValid){
        const [browserLangPrefix] = navigator.language.split('-');
        return browserLangPrefix === 'zh' ? 'zh-CN' : 'en-US';
    }
}
// the package done

export { currentLanguage, LanguageControlPanel as default };
